<form
  [formGroup]="myGroup"
  (keydown.enter)="editMode ? saveCollection($event) : createCollection($event)"
  (ngSubmit)="editMode ? saveCollection($event) : createCollection($event)"
>
  <div class="modal-header">
    <h4 class="v4-collections-crud-header pull-left">
      {{ editMode ? ('collections.editCollection' | translate) : ('collections.createNewCollection' | translate) }}
    </h4>
    <button [attr.aria-label]="'common.close' | translate" class="text" (click)="modalRef.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-floating">
      <input
        type="email"
        formControlName="name"
        ngDefaultControl
        [placeholder]="'collections.collectionName' | translate"
        class="form-control"
        [class.error]="myGroup.get('name').errors?.unic"
      />
      <label for="floatingInput">{{ 'collections.collectionName' | translate }}</label>
      <div
        class="assistive_text_container"
        *ngIf="myGroup.get('name').errors?.unic"
      >
        <span class="assistive_text">{{
          myGroup.get('name').errors?.unic ? ('collections.nameExists' | translate) : ''
        }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="text" *ngIf="editMode" (click)="deleteCollection()">
      {{ 'collections.deleteCollectionButton' | translate }}
    </button>

    <div class="buttons-right-container">
      <button class="text" (click)="modalRef.hide()">{{ 'common.cancel' | translate }}</button>
      <button
        type="submit"
        *ngIf="!editMode"
        [disabled]="!myGroup.valid"
        (click)="createCollection($event)"
      >
        {{ 'common.create' | translate }}
      </button>
      <button
        type="submit"
        *ngIf="editMode"
        [disabled]="!myGroup.valid"
        (click)="saveCollection($event)"
      >
        {{ 'common.save' | translate }}
      </button>
    </div>
  </div>
  <vp-loading-indicator *ngIf="loading"></vp-loading-indicator>
</form>
